module.exports = __webpack_public_path__ + "img/online_checkin.3d53a884.png";